var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-and-commission"},[_c('OLabel',[_vm._v(" "+_vm._s(_vm.locale.orderSummary)+" ")]),_c('div',{staticClass:"summary-and-commission__main-block"},[_c('SummaryBlock')],1),_c('div',{staticClass:"summary-and-commission__commission"},[_c('Commission')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }